<div id="test-route-container">
  <span *ngIf="!testRouteRequest">Test Route is available from the peer connection's right click action menu</span>

  <div *ngIf="testRouteRequest">

    <table id="map-test-route-table">
      <thead>
      <tr>
        <th></th>
        <th>Source</th>
        <th>Destination</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>User:</td>
        <td>{{testRouteRequest.srcUser}}</td>
        <td>{{testRouteRequest.destUser}}</td>
      </tr>
      <tr>
        <td>Host:</td>
        <td>{{testRouteRequest.srcHost}}</td>
        <td>{{testRouteRequest.destHost}}</td>
      </tr>
      <tr>
        <td>Peer Connection:</td>
        <td>{{testRouteRequest.srcPeerConnectionName}}</td>
        <td>{{testRoutePathSelected ? testRoutePathSelected.destPeerConnectionName : ''}}</td>
        <td></td>
      </tr>
      <tr>
        <td>Node:</td>
        <td>{{testRouteRequest.srcNodeName}}</td>
        <td>{{testRoutePathSelected ? testRoutePathSelected.destNodeName : ''}}</td>
      </tr>
      <tr *ngIf="customerDataExist()">
        <td>Customer:</td>
        <td>{{testRouteResult.incomingCustomerName ? testRouteResult.incomingCustomerName : ''}}</td>
        <td>{{testRouteResult.outgoingCustomerName ? testRouteResult.outgoingCustomerName : ''}}</td>
      </tr>
    </table>

    <divider [title]="'Router'"></divider>

    <div class="test-route-router-name-label">
      <label ac-label="Name:">{{routerName}}</label>
    </div>
  </div>

  <div [hidden]="!testRouteResult || !testRouteRequest">
    <divider [title]="'Paths'"></divider>

    <span *ngIf="testRouteResult && testRouteResult.pathsBoxDescription">{{testRouteResult.pathsBoxDescription}}</span>

    <div class="test-route-grid-container" style="height: 165px;" [hidden]="!testRouteResult || testRouteResult.noRoutesFound">
      <ag-grid-angular #agGrid
                       [columnDefs]="columnDefs"
                       (gridReady)="onGridReady()"
                       (rowClicked)="onSelectionChanged($event)"
                       [getRowStyle]="getRowStyle"
                       [suppressRowTransform]="true"
                       style="height: 100%;"
                       class="ag-theme-balham"
                       [gridOptions]="gridOptions">
      </ag-grid-angular>
    </div>

    <div class="show-unselected-rules" [hidden]="!testRouteResult || testRouteResult.noRoutesFound">
      <mat-checkbox name="showUnselectedRules"
                    color="primary"
                    (ngModelChange)="showUnselectedRulesChange($event)"
                    [(ngModel)]="showUnselectedRules">
        Show unselected rules
      </mat-checkbox>
    </div>
  </div>

  <div id="test-route-buttons-container" *ngIf="testRouteRequest">
    <ac-button [ngDisabled]="(selectedPaths && selectedPaths.length > 1)"
               (acClick)="openTestRouteDetailsDialog()"
               buttonValue="Details">
    </ac-button>
    <ac-button (acClick)="clearTestRoute()"
               buttonValue="Clear">
    </ac-button>
    <ac-button (acClick)="repeatTestRoute()"
               buttonValue="Repeat">
    </ac-button>
  </div>
</div>
